<template>
  <div>
    <vxe-form :data="toolbar">
      <vxe-form-item title="关键字" field="searchKey">
        <template #default>
          <vxe-input v-model="toolbar.searchKey" placeholder="请输入姓名、邮箱或域账号" clearable />
        </template>
      </vxe-form-item>
      <vxe-form-item>
        <template #default>
          <vxe-button status="primary" @click="search">查询</vxe-button>
          <vxe-button @click="reset">重置</vxe-button>
          <vxe-button status="success" @click="openAdd">新增</vxe-button>
        </template>
      </vxe-form-item>
    </vxe-form>

    <vxe-table
      ref="table"
      stripe
      show-overflow
      class="mytable-scrollbar"
      :data="tableData"
      :height="tableHeight"
      :loading="loading"
      :row-config="{ height: 36, isHover: true, isCurrent: true }"
    >
      <vxe-column type="seq" title="序号" width="60" />
      <vxe-column title="删除" width="50">
        <template #default="{ row }">
          <vxe-button type="text" icon="fa fa-trash-o" @click="removeRow(row)" />
        </template>
      </vxe-column>
      <vxe-column title="编辑" width="50">
        <template #default="{ row }">
          <vxe-button type="text" icon="fa fa-edit" @click="openEdit(row)" />
        </template>
      </vxe-column>
      <vxe-column field="UserName" title="审核员姓名" width="140" sortable />
      <vxe-column field="UserMail" title="审核员邮箱" min-width="240" sortable />
      <vxe-column field="DomainAccount" title="域账号" width="160" sortable />
      <vxe-column field="CreatedAt" title="创建时间" width="170" sortable>
        <template #default="{ row }">{{ formatDate(row.CreatedAt) }}</template>
      </vxe-column>
    </vxe-table>

    <vxe-pager
      background
      v-model:current-page="pager.currentPage"
      v-model:page-size="pager.pageSize"
      :total="pager.totalResult"
      :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="loadData"
    />
  </div>

  <vxe-modal v-model="form.visible" :title="form.title" width="600" height="230" show-zoom resize>
    <template #default>
      <vxe-form ref="reviewerForm" :data="form.data" :rules="form.rules">
        <vxe-form-item title="安全审核员" field="displayName" span="20" title-width="110px">
          <template #default>
            <vxe-input v-model="form.data.displayName" readonly placeholder="请选择安全审核员" />
          </template>
        </vxe-form-item>
        <vxe-form-item span="4">
          <template #default>
            <vxe-button @click="openUserPicker">选择</vxe-button>
          </template>
        </vxe-form-item>
        <vxe-form-item align="center" span="24">
          <template #default>
            <vxe-button status="success" icon="fa fa-save" @click="save">保存</vxe-button>
          </template>
        </vxe-form-item>
      </vxe-form>
    </template>
  </vxe-modal>

  <vxe-modal v-model="userPicker.visible" title="选择用户" width="720" height="520">
    <template #default>
      <vxe-form>
        <vxe-form-item title="关键字">
          <template #default>
            <vxe-input v-model="userPicker.searchKey" placeholder="请输入姓名或邮箱" clearable />
          </template>
        </vxe-form-item>
        <vxe-form-item>
          <template #default>
            <vxe-button @click="loadUsers">查询</vxe-button>
            <vxe-button status="primary" @click="selectUser">确定</vxe-button>
          </template>
        </vxe-form-item>
      </vxe-form>
      <vxe-table
        ref="userTable"
        height="330"
        :data="userPicker.rows"
        highlight-current-row
        :row-config="{ isCurrent: true, isHover: true }"
        @cell-dblclick="selectUser"
      >
        <vxe-column type="seq" title="序号" width="55" />
        <vxe-column field="UserName" title="姓名" width="120" />
        <vxe-column field="JobZb" title="总部" width="100" />
        <vxe-column field="JobName" title="部门" width="140" />
        <vxe-column field="UserMail" title="邮箱" min-width="220" />
      </vxe-table>
      <vxe-pager
        size="small"
        background
        v-model:current-page="userPicker.currentPage"
        v-model:page-size="userPicker.pageSize"
        :total="userPicker.totalResult"
        @page-change="loadUsers"
      />
    </template>
  </vxe-modal>
</template>

<script>
import Qs from "qs";
import { VXETable } from "vxe-table";

export default {
  name: "SecurityReviewer",
  data() {
    return {
      loading: false,
      tableData: [],
      tableHeight: 400,
      toolbar: { searchKey: "" },
      pager: { currentPage: 1, pageSize: 10, totalResult: 0 },
      form: {
        visible: false,
        title: "新增安全审核员",
        editMode: false,
        data: { userId: 0, originalUserId: 0, displayName: "" },
        rules: { displayName: [{ required: true, message: "请选择安全审核员" }] },
      },
      userPicker: {
        visible: false,
        rows: [],
        searchKey: "",
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    formatDate(value) {
      return value ? String(value).replace("T", " ").slice(0, 19) : "-";
    },
    showError(error) {
      VXETable.modal.message({ content: error.message || String(error), status: "error" });
    },
    search() {
      this.pager.currentPage = 1;
      this.loadData();
    },
    reset() {
      this.toolbar.searchKey = "";
      this.search();
    },
    loadData() {
      this.loading = true;
      const params = Qs.stringify({
        uid: this.$store.state.userID,
        email: this.$store.state.email,
        currentPage: this.pager.currentPage,
        pageSize: this.pager.pageSize,
        searchKey: [this.toolbar.searchKey],
      });
      this.$api.digitalDictManageAPI.getSecurityReviewerList(params)
        .then((res) => {
          if (!res.data.Success) {throw new Error(res.data.Message);}
          const data = res.data.Data;
          this.tableData = data.dataTable || [];
          this.pager.totalResult = data.totalResult || 0;
          this.tableHeight = this.$calTableHeight(this.tableData.length);
        })
        .catch(this.showError)
        .finally(() => { this.loading = false; });
    },
    openAdd() {
      this.form.title = "新增安全审核员";
      this.form.editMode = false;
      this.form.data = { userId: 0, originalUserId: 0, displayName: "" };
      this.form.visible = true;
    },
    openEdit(row) {
      this.form.title = "编辑安全审核员";
      this.form.editMode = true;
      this.form.data = {
        userId: row.UserId,
        originalUserId: row.UserId,
        displayName: `${row.UserName || row.DomainAccount}(${row.UserMail || row.DomainAccount})`,
      };
      this.form.visible = true;
    },
    openUserPicker() {
      this.userPicker.searchKey = "";
      this.userPicker.currentPage = 1;
      this.userPicker.visible = true;
      this.loadUsers();
    },
    loadUsers() {
      const params = Qs.stringify({
        uid: this.$store.state.userID,
        email: this.$store.state.email,
        currentPage: this.userPicker.currentPage,
        pageSize: this.userPicker.pageSize,
        searchKey: [this.userPicker.searchKey, ""],
      });
      this.$api.systemManageAPI.getUserList(params)
        .then((res) => {
          if (!res.data.Success) {throw new Error(res.data.Message);}
          const data = res.data.Data;
          this.userPicker.rows = data.dataTable || [];
          this.userPicker.totalResult = data.totalResult || 0;
        })
        .catch(this.showError);
    },
    selectUser() {
      const row = this.$refs.userTable && this.$refs.userTable.getCurrentRecord();
      if (!row) {
        VXETable.modal.message({ content: "请选择一行用户", status: "info" });
        return;
      }
      this.form.data.userId = row.Id;
      this.form.data.displayName = `${row.UserName || row.uid}(${row.UserMail || row.uid})`;
      this.userPicker.visible = false;
    },
    async save() {
      const errors = await this.$refs.reviewerForm.validate();
      if (errors) {return;}
      const method = this.form.editMode ? "updateSecurityReviewer" : "addSecurityReviewer";
      this.$api.digitalDictManageAPI[method](Qs.stringify(this.form.data))
        .then((res) => {
          if (!res.data.Success) {throw new Error(res.data.Message);}
          VXETable.modal.message({ content: "保存成功", status: "success" });
          this.form.visible = false;
          this.loadData();
        })
        .catch(this.showError);
    },
    async removeRow(row) {
      const result = await VXETable.modal.confirm("确定删除该安全审核员吗？");
      if (result !== "confirm") {return;}
      this.$api.digitalDictManageAPI.deleteSecurityReviewer(Qs.stringify({ userId: row.UserId }))
        .then((res) => {
          if (!res.data.Success) {throw new Error(res.data.Message);}
          VXETable.modal.message({ content: "删除成功", status: "success" });
          this.loadData();
        })
        .catch(this.showError);
    },
  },
};
</script>

<style type="text/css">
td.vxe-body--column {
  vertical-align: middle;
}
</style>
